import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Translates the `?error=` codes that `/auth/google/callback` redirects with
 * into something a human can act on.
 */
const MESSAGES: Record<string, string> = {
  access_denied: 'Sign-in was canceled. Approve the Google prompt to continue.',
  invalid_state: 'That sign-in link expired. Please try again.',
  missing_code: 'Google did not return an authorization code. Please try again.',
  exchange_failed: 'We could not reach Google. Please try again in a moment.',
  google_exchange_failed: 'We could not reach Google. Please try again in a moment.',
  email_not_verified: 'Your Google account does not have a verified email address.',
  domain_not_allowed: 'Only @a2.agency accounts can access this workspace.',
  gmail_scope_required:
    'We need permission to send email on your behalf. Please approve the Gmail access request.',
  signin_failed: 'We could not sign you in. Contact an admin if this keeps happening.',
};

export function useLoginError() {
  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get('error');

  const message = useMemo(
    () => (code ? (MESSAGES[code] ?? 'Something went wrong signing you in.') : null),
    [code],
  );

  const dismiss = () => {
    searchParams.delete('error');
    setSearchParams(searchParams, { replace: true });
  };

  return { code, message, dismiss };
}
